import axios from 'axios';

import {
	JWT_SESSION_STORAGE,
	ORG_INFO_SESSION_STORAGE,
	ORG_SESSION_STORAGE,
	OTP_SESSION_STORAGE,
	USER_ID_SESSION_STORAGE,
	USER_INFO_SESSION_STORAGE,
} from 'src/helpers/constant';
import { initializePendo } from 'src/helpers/pendoInitializer';
import type {
	UserOrg,
	fetchUserResponse,
	otpLoginResponse,
	otpResponse,
	userOrgResponse,
} from 'src/interfaces/User';

function createApiUri(path: string = '') {
	return '/api/v1/iam' + path;
}

export const otpLoginUri = createApiUri('/otp-login');

export async function otpLogin(otp: string) {
	const response = await axios
		.create()
		.post<otpLoginResponse>(otpLoginUri, undefined, {
			headers: {
				Authorization: `Bearer ${otp}`,
			},
		});
	return {
		...response.data.data.userProfile,
		platformToken: response.headers['platform-token'],
	};
}

export const createFetchUserUri = (userId: string) =>
	createApiUri('/users') + '/' + userId;

export async function fetchUser(userId: string) {
	const response = await axios.get<fetchUserResponse>(
		createFetchUserUri(userId)
	);
	return response.data.data;
}

export async function fetchOrgs() {
	const userOrgsPath = 'clients/orgs';
	const response = await axios.get<userOrgResponse>(
		createFetchUserUri(userOrgsPath)
	);
	return response.data.data;
}

export const logoutUserUri = createApiUri('/logout');
export async function logoutUser() {
	await axios.post(logoutUserUri);
	sessionStorage.clear();
	window.dispatchEvent(new Event('jwt'));
}

export const getOtpUri = createApiUri('/otp');
export async function renewToken() {
	const otpResponse = await axios.get<otpResponse>('/api/v1/iam/otp');

	const otp = otpResponse.data.data.id;

	const userIds = await otpLogin(otp);

	const userOrgs = await fetchOrgs();

	if (userIds.platformToken) {
		sessionStorage.setItem(OTP_SESSION_STORAGE, otp);
		sessionStorage.setItem(JWT_SESSION_STORAGE, userIds.platformToken);
		sessionStorage.setItem(USER_ID_SESSION_STORAGE, userIds.userId);
		const userInfo = await fetchUser(userIds.userId);
		if (userInfo) {
			sessionStorage.setItem(
				USER_INFO_SESSION_STORAGE,
				JSON.stringify(userInfo)
			);
		}
		window.dispatchEvent(new Event('jwt'));
	}
	if (userOrgs) {
		sessionStorage.setItem(
			ORG_INFO_SESSION_STORAGE,
			JSON.stringify(getOrgInfo(userOrgs))
		);
	}
	initializePendo();
}

function simplifiedUserOrg(currentOrgInfo: UserOrg) {
	const userOrg: UserOrg = {
		id: currentOrgInfo.id,
		name: currentOrgInfo.name,
		rootOrg: currentOrgInfo.rootOrg,
		accessible: currentOrgInfo.accessible,
		clientId: currentOrgInfo.clientId,
	};
	return userOrg;
}

export const getOrgInfo = (userOrgs: UserOrg[]) => {
	const currentOrgInfo = userOrgs.find(
		(org) => org.id === sessionStorage.getItem(ORG_SESSION_STORAGE)
	);

	if (currentOrgInfo) {
		return simplifiedUserOrg(currentOrgInfo);
	}
};
